export default "__VITE_ASSET__Bte7CkxD__"